export default __webpack_public_path__ + "static/media/06.1dedcfa0.jpg";